<div class="component select-example">
    <h2>Select</h2>
    <p>
        Width of select-boxes is determined by its containing elements width.
    </p>
    <div class="example">
        <p>
            Current value: {{selectedItem}}
        </p>
        <sbw-select name="selectDemo1" [(ngModel)]="selectedItem" [items]="selectItems" [key]="'code'" [text]="'description'"></sbw-select>
    </div>
    <div class="example">
        <p>
            When selected value is not in list, a blank item is inserted
        </p>
        <p>
            Current value: {{blankSelectedItem}}
        </p>
        <sbw-select name="selectDemo2" [(ngModel)]="blankSelectedItem" [items]="selectItems" [key]="'code'" [text]="'description'"></sbw-select>
    </div>
    <div class="example">
        <p>
            A placeholder can be supplied which will be shown on missing values. The model must be initialized to null(undefined will not work)
        </p>
        <p>
            Current value: {{placeholderSelectedItem}}
        </p>
        <sbw-select name="selectDemo2" [(ngModel)]="placeholderSelectedItem" [items]="selectItems" [key]="'code'" [text]="'description'"
            [placeholder]="'Please select something'"></sbw-select>
    </div>
    <div class="example">
        <p>
            For use in iteration
        </p>
        <div *ngFor="let obj of selectDemoObjects; let i = index;">
            <div>
                Current value: {{obj.id}} {{obj.selectedItem.code}} {{obj.selectedItem.name}}
            </div>
            <sbw-select [(ngModel)]="obj.selectedItem.code" (ngModelChange)="multiSelectionChange(obj, $event)" [items]="selectItems" [key]="'code'" [text]="'description'"></sbw-select>
        </div>
    </div>
</div>